export default __webpack_public_path__ + "static/media/art-pro-red-4.16804d3e.png";